/**
 * Hook to orchestrate the "AutocompleteField" component. This hook is not supposed to be used out of it.
 */

import Autocomplete from '@mui/material/Autocomplete';
import { useCallback, useState } from 'react';

export default function useAutocompleteField() {
  const [isOpen, setIsOpen] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const handleOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const handleInputChange = useCallback<
    Exclude<React.ComponentProps<typeof Autocomplete>['onInputChange'], undefined>
  >((_event, newValue) => {
    setInputValue(newValue);
  }, []);

  return { handleClose, handleInputChange, handleOpen, inputValue, isOpen };
}
